export default __webpack_public_path__ + "static/media/element_85.8c98199f.webp";